import styled from '@emotion/styled';
import vars from '@variables';
import { StyledChevronUpAtom } from '@atoms/icon-atoms/nav-icon-atoms';
import { keyframes, css } from '@emotion/react';

const slideDownAndFadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const UtilityBarContainer = styled.div`
  border-bottom: 1px dashed ${vars.borderGrey};
`;

export const UtilityBarContent = styled.div<{ hidePublishDate: boolean }>`
  max-width: ${vars.contentMaxWidth};
  display: flex;
  align-items: center;
  padding: 12px 24px;
  min-height: 60px;
  margin: 0 auto;

  ${({ hidePublishDate }) =>
    hidePublishDate &&
    css`
      justify-content: flex-start;
    `}

  @media screen and (max-width: ${vars.breakPointTablet}) {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 24px;
    row-gap: ${vars.spacingS};
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 30px;
  background-color: ${vars.borderGrey};
  margin: 0 1.5rem;
  @media screen and (max-width: ${vars.breakPointTablet}) {
    display: none;
  }
`;

export const TopicsContainer = styled.div`
  display: flex;
  @media screen and (max-width: ${vars.breakPointTablet}) {
    display: none;
  }
  gap: 8px;
`;

export const Topic = styled.a`
  display: flex;
  align-items: center;
  padding: 0em 0.6em;
  height: 30px;
  border-radius: 200px;
  border: 1px solid ${vars.borderGrey};
  ${vars.fontSize2};
  text-decoration: none;
  white-space: nowrap;
  max-width: 100%;
`;

export const LanguageSelector = styled.select`
  margin-left: auto;
`;

export const PublishDate = styled.div`
  > span,
  > time {
    color: ${vars.lightGrey};
    ${vars.fontSize1};
  }

  @media screen and (max-width: ${vars.breakPointTablet}) {
    order: -1;
    margin-right: none;

    > span,
    > time {
      ${vars.fontSize2};
    }
  }
`;

export const AuthorSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Avatar = styled.div`
  min-width: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  aspect-ratio: 1/1;
  overflow: hidden;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const AuthorBio = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const AuthorName = styled.span`
  font-weight: bold;
  text-align: left;
  ${vars.fontSize3};
  @media screen and (max-width: ${vars.breakPointTablet}) {
    ${vars.fontSize4};
  }
`;

export const AuthorTitle = styled.span`
  display: block;
  text-align: left;
  margin-top: 2px;
  color: ${vars.lightGrey};
  ${vars.fontSize1};
  @media screen and (max-width: ${vars.breakPointTablet}) {
    ${vars.fontSize2};
  }
`;

export const SelectLanguageContainer = styled.div`
  position: relative;
  margin-left: auto;

  @media screen and (max-width: ${vars.breakPointTablet}) {
    margin-top: ${vars.spacingM};
    width: 100%;
    margin-left: 0;
    flex-grow: 1;
  }
`;

export const SelectBox = styled.div`
  display: flex;
  min-width: 100px;
  align-items: center;
  border: 1px solid ${vars.borderGrey};
  padding-left: 0.4em;
  padding-right: 0.8em;
  height: 30px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  ${vars.fontSize2};

  @media screen and (max-width: ${vars.breakPointTablet}) {
    padding: 0.4em 0.8em 0.4em 0.4em;
  }
`;

export const SelectedLanguage = styled.span`
  flex-grow: 1;
  text-align: left;
`;

export const ChevronIcon = styled(StyledChevronUpAtom)<{ isOpen: boolean }>`
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0)' : 'rotate(180deg)')};
`;

export const OptionsBox = styled.ul<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  min-width: 130px;
  text-align: left;
  margin-top: 4px;
  padding: 12px;
  background-color: white;
  border: 1px solid ${vars.borderGrey};
  border-radius: 12px;
  list-style: none;
  font-size: 14px;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s ease-in-out,
    visibility 0.2s ease-in-out;
  // is +1 because of sectionTitleBorder has z-index: 200
  z-index: 201;

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      visibility: visible;
      animation: ${slideDownAndFadeIn} 0.2s ease-in-out;
    `}
`;

export const OptionItem = styled.li`
  padding: 12px 0px;
  cursor: pointer;
  text-transform: capitalize;
`;

export const TopicsLanguageContainer = styled.div<{ alignLeft?: boolean }>`
  display: flex;
  align-items: center;
  margin-left: ${({ alignLeft }) => (alignLeft ? `0` : `auto`)};

  @media screen and (max-width: ${vars.breakPointTablet}) {
    width: 100%;
  }
`;
